import { motion } from 'framer-motion'

const LeaderboardTabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="flex flex-wrap gap-2 sm:gap-1 bg-white/60 backdrop-blur-sm p-1 rounded-2xl border border-neutral-200/50">
      {tabs.map((tab) => {
        const Icon = tab.icon
        const isActive = activeTab === tab.id
        
        return (
          <motion.button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`relative flex items-center gap-2 px-4 sm:px-6 py-3 rounded-xl font-medium transition-all duration-200 min-w-0 flex-1 sm:flex-none ${
              isActive
                ? 'text-white shadow-lg'
                : 'text-neutral-600 hover:text-neutral-900 hover:bg-white/80'
            }`}
            whileHover={{ scale: isActive ? 1 : 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            {/* Active tab background */}
            {isActive && (
              <motion.div
                layoutId="activeTab"
                className="absolute inset-0 bg-gradient-to-r from-primary-teal to-primary-teal/80 rounded-xl"
                transition={{ type: "spring", duration: 0.6 }}
              />
            )}
            
            {/* Tab content */}
            <div className="relative flex items-center gap-2 min-w-0">
              <Icon className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" />
              <span className="text-sm sm:text-base font-medium truncate">
                {tab.label}
              </span>
            </div>
          </motion.button>
        )
      })}
    </div>
  )
}

export default LeaderboardTabs